import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OtaBatchCreateComponent } from './ota-batch-create.component';

const routes: Routes = [
  {
    path: 'ota-batch-create',
    data: { name: 'ota-batch-create', isTab: false },
    component: OtaBatchCreateComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OtaBatchCreateRoutingModule {}
